import API from "./API";

const thumbnailUrlCache = new Map();

export const getItem = (contentType, itemId, json) => {
  return API.get(`${contentType}/${itemId}`, { requiresAuth: true }).then((response) => response.data);
};

export const getThumbnail = async (id) => {
  if (!id) return "";

  if (thumbnailUrlCache.has(id)) {
    return thumbnailUrlCache.get(id);
  }

  try {
    const response = await API.get(`thumbnails/${id}`);
    const thumbnailUrl = response?.data?.url || "";
    if (thumbnailUrl) {
      thumbnailUrlCache.set(id, thumbnailUrl);
    }
    return thumbnailUrl;
  } catch (error) {
    console.error(`Error fetching thumbnail for ${id}:`, error);
    return "";
  }
};
